import { FlightProps } from './FlightProps';
import { useState, useEffect, useRef } from 'react';
import { Button } from '@mantine/core';
import { TimePicker } from "@progress/kendo-react-dateinputs";
import { getFormattedDate,
          getUtcString,
          getFormattedTime,
          getMinTobt,
          getMaxTobt,
          getDefaultTobt,
          prepareForLogout,
          getRollup,
          getUtcFormat,
          isTobtValid,
          isDateInThePast} from './Helpers';
import { format  } from "date-fns";

export const FlightInformation = (props: FlightProps) => {

  let item = props;
  const [tobtValue, setTobtValue] = useState(getDefaultTobt());
  const [defaultTobt, setDefaultTobt] = useState(getFormattedTime(item.properties.target_off_block_time_aerobahn_field_name));
  const [minTobtValue, setMinTobtValue] = useState(getMinTobt());
  const [maxTobtValue, setMaxTobtValue] = useState(getMaxTobt());
  const [showError, setShowError] = useState(true);
  const [disableUpdate, setDisableUpdate] = useState(false);
  const [tobtModified, setTobtModified] = useState(false);
  const tobtModifiedRef = useRef<boolean>(tobtModified);
  const tobtValueRef = useRef<Date>(tobtValue);
  var disableEdit = true;
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  useEffect(() => {
    tobtModifiedRef.current = tobtModified;
    tobtValueRef.current = tobtValue;
  }, [tobtModified, tobtValue]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const newTime = new Date();

      // Check if the minute has changed
      if (newTime.getMinutes() !== currentTime.getMinutes()) {
        setCurrentTime(newTime);
        const maxTobt = getMaxTobt();
        const minTobt = getMinTobt();
        setMaxTobtValue(maxTobt);
        setMinTobtValue(minTobt);
        if (!tobtModifiedRef.current) {
          setTobtValue(getMinTobt());
        } else {
          if (!isTobtValid(tobtValueRef.current, minTobt, maxTobt)) {
            setDisableUpdate(true);
          } else {
            setDisableUpdate(false);
          }
        }
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [currentTime]);

  function handleChange (value: Date | null ) {
    if (value != null) {
        setTobtModified(true);
        // AERO-47363 reset value with the min tobt's date to fix bug where dates are incorrect if a user updates multiple tobts that have different days
        var resetDate = new Date(minTobtValue);
        resetDate.setHours(value.getHours());
        resetDate.setMinutes(value.getMinutes());
        value = resetDate;
        setTobtValue(resetDate);
     if (isTobtValid(value, getMinTobt(), getMaxTobt())){
        setDisableUpdate(false);
        // AERO-47363 needed because the time picker does not handle new days
        if (maxTobtValue.getDay() != minTobtValue.getDay() && isDateInThePast(value)) {
          var nextDayDate = new Date(maxTobtValue);
          nextDayDate.setHours(value.getHours());
          nextDayDate.setMinutes(value.getMinutes());
          setTobtValue(nextDayDate);
        }
      } else {
        setDisableUpdate(true);
      }
    }
  }

  function updateTobt() {
    var sessionVal = '';
    if (sessionStorage.getItem('sessionId')) {
        if (sessionStorage && sessionStorage.getItem('sessionId')) {
            const value = sessionStorage.getItem('sessionId');
            if (value != null) {
                sessionVal = value;
            }
        }
    }
    const request = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Authorization',
            'X-Saab-SessionID': sessionVal
        }
    };
    fetch('/externalApi/flight/active/update' + createParamString(item, tobtValue), request ).then(function (response) {
      if (response && response.status && response.status === 401) {
        props.updateShowSessionError(true);
        prepareForLogout();
      } else if (!response.ok) {
        const error: any = new Error('HTTP error! status: ${response.status}');
        error.status = response.status;
        throw error;
      }
      return response.json();
    }).then(function (result) {
      setDefaultTobt(getFormattedDate(getUtcString(tobtValue)));
      item.properties.target_off_block_time_aerobahn_field_name = getUtcFormat(tobtValue);
      props.performSearch();
    }).catch((err : any) => {
      console.warn('Error with status code: ' + err);
      if (err === 401) {
        prepareForLogout();
        props.updateShowSessionError(true);
      }
    });
  }

  function createParamString(flightProps: FlightProps, value: Date) {
    var paramString = '';
    if (flightProps) {
      if (flightProps.flightPlanId) {
        paramString += '?flightPlanId=' + flightProps.flightPlanId;
      } else {
        console.log('flight plan is a required field');
        return;
      }
      paramString += '&field=target_off_block_time_field_name';
      if (value) {
        paramString += '&value=' + getUtcFormat(value);
      } else {
        // empty value is allowed
        paramString += '&value=';
      }
      //TODO: do we need any of these?
      //paramString += '&returnFields=true&searchFieldGroup=tobt_mobile_search&fieldGroup=tobt_mobile&stateGroup=tobt_mobile&direction=outbound';
    }
    return paramString;
  }

  if (sessionStorage.getItem('enableEdit')) {
    if (sessionStorage.getItem('enableEdit') == 'true') {
      disableEdit = false;
    } else {
      disableEdit = true;
    }
  }

  return (
    <div>
      <div style={{ padding: 10, borderBottom: '1px solid lightgrey', backgroundColor: 'rgb(0.0, 122.0, 255.0, 0.6)'}}>
        <table className="flights">
          <tbody>
            <tr>
              <td>
                  <strong>
                      {item.callsign}
                  </strong>
                </td>
                <td style={{paddingLeft:'15%'}}>
                  {getRollup(item.properties, 'targetOffBlockTimeRollup')}
                </td> 
            </tr>
            <tr>
              <td>
                {item.properties.tail_number_field_name}
              </td>
              <td style={{paddingLeft:'15%'}}>
                  {getRollup(item.properties, 'targetStartupApprovalTimeRollup')}
              </td> 
            </tr>
            <tr>
              <td>
                {item.properties.assigned_gate_aerobahn_field_name_short} | {item.properties.dest_airport_field_name}
              </td>
              <td style={{paddingLeft:'15%'}}>
                CTOT:{getFormattedTime(item.properties.edct_aerobahn)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='k-listview-item' style={{ margin: 0, padding:'10px'}}>
        <table>
          <tbody>
            <tr>
              <td>
                Current TOBT: {defaultTobt}
              </td>
              <td>                
                <Button 
                  variant="subtle"
                  id="updateButton"
                  style={{fontWeight:300, marginLeft: -50}}
                  onClick={updateTobt}
                  disabled={disableEdit || disableUpdate}
                >
                  <strong>Update</strong>
                </Button>
              </td>
            </tr>
            <tr>
              <td>
                Today at:
              </td>
            </tr>
            <tr>
              <td style={{paddingBottom:'10%', paddingTop: '8%', display:'inline-flex'}}>
                <TimePicker format="HH:mm" 
                            defaultValue={getDefaultTobt()} 
                            value={tobtValue} 
                            disabled={disableEdit}
                            nowButton={false}
                            onChange={(event) => handleChange(event.value)}/>
              </td>
            </tr>
            <tr style={{ background: 'white', color: 'grey', padding: 4, fontSize: 'x-small'}}>
              { showError ? 
                <td>TOBT must be between {format(minTobtValue, 'HH:mm')} and {format(maxTobtValue, 'HH:mm')}</td>
              : null }
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
